const splitArrayIntoChunks = (arr, chunksLen) => {
    const n = arr.length
    let chunks = []
    let i = 0
 
    while (i < n) {
      chunks.push(arr.slice(i, i += chunksLen));
    }

    return chunks;
}

export default splitArrayIntoChunks